module.exports = __webpack_public_path__ + "static/fipcsafaribaby-798803d40d1533ad8ddbe4d360af8f20.jpeg";